// extracted by mini-css-extract-plugin
export var container = "_ch-0";
export var icon = "_ch-1";
export var text = "_ch-2";